import styled from "styled-components";

export const Header = styled.header`
  background-color: #61d7d7;
  height: 5rem;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
`;

export const HeaderInner = styled.div`
  width: 50rem;
  margin: auto;
`;

export const H1 = styled.h1`
  background-image: url(/govpass/govpasslogo.jpg);
  background-size: 10rem;
  background-repeat: no-repeat;
  background-position: left center;
  text-indent: -10000rem;
`;
